export default __webpack_public_path__ + "static/media/closeIconGrey.b60771cd.svg";